/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Guide_TitleInputs */

const en_fw_guide_title = /** @type {(inputs: Fw_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firefly Wedding anime: what to know before you press play`)
};

const zh_fw_guide_title = /** @type {(inputs: Fw_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁动画：开看之前你需要知道的事`)
};

/**
* | output |
* | --- |
* | "Firefly Wedding anime: what to know before you press play" |
*
* @param {Fw_Guide_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_guide_title = /** @type {((inputs?: Fw_Guide_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Guide_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_guide_title(inputs)
	return zh_fw_guide_title(inputs)
});
export { fw_guide_title as "fw.guide.title" }